import moment from 'moment';

// For a sparse list of available days, return a "disabled" range
// between each pair of days
export function getDisabledDates(dates) {
  let disabledRanges = [];
  disabledRanges.push({
    before: dates[0].toDate()
  });
  dates.forEach((date, index) => {
    if (index + 1 < dates.length) {
      const dayDiff = dates[index + 1].diff(dates[index], 'days');
      if (dayDiff > 1) {
        disabledRanges.push({
          from: moment(dates[index]).add(1, 'days').toDate(),
          to: moment(dates[index + 1]).subtract(1, 'days').toDate()
        });
      }
    }
  });
  disabledRanges.push({
    after: dates[dates.length - 1].toDate()
  });
  return disabledRanges;
}
